import { expensifyLinkError } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const linkExpensifyError = () => addMessage(expensifyLinkError);
export default linkExpensifyError;
